import {useCallback, useState} from 'react'

export function useOptimizeRouteCustomModal() {
  const [isOptimizeRouteCustomModalHooksOpened, setIsOptimizeRouteCustomModalHooksOpened] = useState(false)

  const openOptimizeRouteCustomModalHandler = useCallback(() => {
    setIsOptimizeRouteCustomModalHooksOpened(true)
  }, [])

  const closeOptimizeRouteCustomModalHandler = useCallback(() => {
    setIsOptimizeRouteCustomModalHooksOpened(false)
  }, [])

  return {
    isOptimizeRouteCustomModalHooksOpened,
    openOptimizeRouteCustomModalHandler,
    closeOptimizeRouteCustomModalHandler,
  }
}
